import React from "react";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { Helmet } from 'react-helmet-async';
import { BASE_URL } from "../services/config";
import { Button, Card, CardBody } from "@heroui/react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import heroBackground from "../assets/images/product-banner.png";
import productCandles from "../assets/images/products/candle-main.png";
import productDiffuse from "../assets/images/products/diffuse-main.png";
import productSashe from "../assets/images/products/sashe-main.png";
import productMelts from "../assets/images/products/melts-main.png";
import productAuto from "../assets/images/products/auto-main.png";
import productMasage from "../assets/images/products/massage-main.png";
import productLanch from "../assets/images/products/lanch-candle-main.png";
import productDecorate from "../assets/images/products/decorate-main.png";

interface ProductsOverviewPageProps {
  onCategorySelect: (category: string) => void;
}

interface ProductCategory {
  key: string;
  name: string;
  link_info: string;
  description: string;
  features: string[];
  image: string;
}

export const ProductsOverviewPage: React.FC<ProductsOverviewPageProps> = ({ onCategorySelect }) => {
  const location = useLocation();
  const productCategories: ProductCategory[] = [
    {
      key: "candles",
      name: "Ароматические свечи",
      link_info: "/product/candles",
      description: "Роскошные свечи из натурального воска с изысканными ароматическими композициями. Создают уютную, расслабляющую атмосферу и наполняют пространство любимыми ароматами.",
      features: [
        "100% натуральный кокосовый воск",
        "Хлопковый и деревяные фитили",
        "Премиальные парфюмерные масла",
        "Время горения до 50 часов",
        "Ручная работа"
      ],
      image: `${productCandles}`
    },
    {
      key: "massage_candles",
      name: "Массажные свечи",
      link_info: "/product/massage_candles",
      description: "Инновационные свечи, воск которых при плавлении превращается в теплое масло для массажа. Изготовлены из натуральных масел, которые питают и увлажняют кожу, создавая уникальный опыт ароматерапии.",
      features: [
        "Натуральные масла ши и виноградной косточки",
        "Низкая температура плавления (около 40°C)",
        "Увлажняющие, питающие и омолаживающие свойства",
        "Ароматерапевтический эффект",
        "Полностью натуральный состав"
      ],
      image: `${productMasage}`
    },
    {
      key: "diffusers",
      name: "Диффузоры",
      link_info: "/product/diffusers",
      description: "Стильный и безопасный способ наполнить пространство любимым ароматом без использования открытого огня. Идеальное решение для постоянной ароматизации любых помещений.",
      features: [
        "Стеклянный флакон премиум-класса",
        "Ароматические масла премиум класса",
        "Фибровые палочки для равномерного распространения аромата",
        "Длительность аромата до 3-4 месяцев",
        "Безопасное использование без нагрева"
      ],
      image: `${productDiffuse}`
    },
    {
      key: "sachets",
      name: "Саше",
      link_info: "/product/sachets",
      description: "Компактные ароматизаторы для небольших пространств — шкафов, гардеробных, комодов или автомобиля. Идеально подходят для создания атмосферы свежести в ограниченном пространстве.",
      features: [
        "Ароматические масла премиум-класса",
        "Компактный размер для любых пространств",
        "Сохранение аромата до 2-3 месяцев",
        "Биоразлагаемый продукт"
      ],
      image: `${productSashe}`
    },
    // {
    //   key: "melts",
    //   name: "Мелтсы",
    //   link_info: "/product/melts",
    //   description: "Восковые плитки для аромаламп — альтернатива свечам, позволяющая быстро наполнить помещение желаемым ароматом и легко менять ароматические композиции по настроению.",
    //   features: [
    //     "Натуральный соевый и кокосовый воск",
    //     "Высококонцентрированные ароматические масла",
    //     "Быстрое распространение аромата",
    //     "Возможность комбинирования разных ароматов",
    //     "Многоразовое использование"
    //   ],
    //   image: `${productMelts}`
    // },
    {
      key: "auto_perfumes",
      name: "Автопарфюм",
      link_info: "/product/auto_perfumes",
      description: "Стильные ароматизаторы для автомобиля премиум-класса. Создают приятную атмосферу в салоне вашего автомобиля, не перебивая естественные ароматы и не вызывая головной боли.",
      features: [
        "Элегантный минималистичный дизайн",
        "Ароматические масла премиум-класса",
        "Сбалансированная интенсивность аромата",
        "Безопасное крепление к зеркалу"
      ],
      image: `${productAuto}`
    },
    // {
    //   key: "gift_sets",
    //   name: "Подарочные наборы",
    //   link_info: "/product/gift_sets",
    //   description: "Элегантные комбинации наших продуктов, идеально подобранные для создания гармоничной ароматической атмосферы или в качестве изысканного подарка для близких и коллег.",
    //   features: [
    //     "Премиальная упаковка из экологичных материалов",
    //     "Гармоничные комбинации продуктов",
    //     "Возможность персонализации",
    //     "Карточка с описанием ароматов и рекомендациями",
    //     "Идеальное решение для подарка"
    //   ],
    //   image: "https://img.heroui.chat/image/furniture?w=800&h=600&u=gift_feature"
    // },
    // {
    //   key: "table_candles",
    //   name: "Столовые свечи",
    //   link_info: "/product/table_candles",
    //   description: "Элегантные свечи для создания особой атмосферы за ужином или праздничным столом. Отличаются изысканным дизайном, равномерным горением и отсутствием запаха, что позволяет наслаждаться ароматами блюд без искажений.",
    //   features: [
    //     "Не содержат ароматических добавок",
    //     "Капле-устойчивый состав",
    //     "Длительное время горения (8-10 часов)",
    //     "Не коптят и не мерцают",
    //     "Доступны различной высоты и диаметра"
    //   ],
    //   image: `${productLanch}`
    // },
    {
      key: "decorative_candles",
      name: "Декоративные свечи",
      link_info: "/product/decorative_candles",
      description: "Уникальные свечи необычных форм и дизайна, которые становятся ярким акцентом в интерьере даже в нежженом виде. Создаются и окрашиваются вручную, что делает каждую свечу настоящим произведением искусства.",
      features: [
        "Натуральный пчелиный, оливковый и кокосовые воска",
        "Можно использовать как элемент декора",
        "Устойчивая структура, не деформируется при хранении",
        "Доступны в различных цветовых решениях"
      ],
      image: `${productDecorate}`
    }
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: [0.16, 1, 0.3, 1]
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>Наша продукция — SAFONOVA</title>
        <meta name="description" content="Обзор продуктов SAFONOVA: свечи, диффузоры, саше и другие линии продукции премиум-класса" />
        <link rel="canonical" href={`${BASE_URL || ''}${location?.pathname || '/products'}`} />
        <meta property="og:title" content="Наша продукция — SAFONOVA" />
        <meta property="og:description" content="Обзор продуктов SAFONOVA: свечи, диффузоры, саше и другие линии продукции премиум-класса" />
        <meta property="og:url" content={`${BASE_URL || ''}${location?.pathname || '/products'}`} />
        {/* ItemList JSON-LD for product category overview */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "ItemList",
            "itemListElement": productCategories.map((c, i) => ({
              "@type": "ListItem",
              "position": i + 1,
              "url": `${BASE_URL || ''}${c.link_info}`
            }))
          })}
        </script>
      </Helmet>
      {/* Hero Banner */}
      <section 
        className="relative flex items-center py-32 md:py-40"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0.10)), url('${heroBackground}')`,
          backgroundPosition: "center 80%",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat"
        }}
      >
        <div className="container mx-auto px-6 md:px-12">
          <motion.div 
            className="max-w-3xl"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          >
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-light mb-6 text-white text-shadow">
              Наша <span className="font-semibold">продукция</span>
            </h1>
            <p className="text-lg md:text-xl text-white/90 mb-8 max-w-xl text-shadow">
              Подробное описание всех категорий нашей продукции ручной работы из премиальных материалов
            </p>
          </motion.div>
        </div>
      </section>

      {/* Products Overview Content */}
      <section className="py-24 bg-background">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light mb-4">Наши <span className="font-medium">линейки продукции</span></h2>
            <p className="text-foreground/70 max-w-2xl mx-auto">
              Познакомьтесь подробнее с каждой категорией наших товаров и их особенностями
            </p>
          </div>

          <motion.div
            className="space-y-24"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
          >
            {productCategories.map((category, index) => (
              <motion.div 
                key={category.key} 
                className={`flex flex-col ${index % 2 === 0 ? 'lg:flex-row' : 'lg:flex-row-reverse'} gap-12 items-center`}
                variants={itemVariants}
              >
                <div className="w-full lg:w-1/2">
                  <div className="relative overflow-hidden">
                    <img 
                      src={category.image} 
                      alt={category.name}
                      className="w-full h-auto object-cover" 
                    />
                    <div className={`absolute inset-0 bg-gradient-to-b ${index % 2 === 0 ? 'from-transparent via-transparent to-background/30' : 'from-transparent via-transparent to-background/30'} pointer-events-none`}></div>
                  </div>
                </div>
                
                <div className="w-full lg:w-1/2">
                  <h3 className="text-3xl font-light mb-4">{category.name}</h3>
                  <p className="text-foreground/80 mb-6 text-lg">{category.description}</p>
                  
                  <Card className="border border-divider bg-content2/50 mb-6" disableRipple>
                    <CardBody className="p-6">
                      <h4 className="text-lg font-medium mb-4">Особенности</h4>
                      <ul className="space-y-2">
                        {category.features.map((feature, i) => (
                          <li key={i} className="flex items-start gap-3">
                            <div className="mt-1 text-primary">
                              <Icon icon="lucide:check" width={18} />
                            </div>
                            <span>{feature}</span>
                          </li>
                        ))}
                      </ul>
                    </CardBody>
                  </Card>
                  
                  <div className="flex flex-wrap gap-4">
                    {/* <Button 
                      color="primary" 
                      size="lg"
                      endContent={<Icon icon="lucide:arrow-right" width={18} />}
                      onPress={() => onCategorySelect(category.key)}
                    >
                      Смотреть товары
                    </Button> */}
                    
                    <Button 
                      variant="flat" 
                      // color="default"
                      color="primary"
                      size="lg"
                      endContent={<Icon icon="lucide:info" width={18} />}
                      as={RouterLink}
                      to={category.link_info}
                    >
                      Подробнее
                    </Button>
                  </div>
                </div>
              </motion.div>
            ))}
          </motion.div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="py-24 bg-content2">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <h2 className="text-3xl md:text-4xl font-light mb-4">Часто задаваемые <span className="font-medium">вопросы</span></h2>
            <p className="text-foreground/70 max-w-2xl mx-auto">
              Ответы на самые популярные вопросы о нашей продукции
            </p>
          </div>

          <div className="max-w-3xl mx-auto">
            <Card className="border border-divider mb-4" disableRipple>
              <CardBody className="p-6">
                <h3 className="text-lg font-medium mb-2">Из каких материалов изготавливаются ваши продукты?</h3>
                <p className="text-foreground/70">
                  Мы используем только натуральные высококачественные материалы. Наши свечи изготавливаются из кокосового воска с добавлением премиальных парфюмерных масел, диффузоры содержат безопасные для здоровья ароматические композиции, а упаковка создана из экологически чистых материалов.
                </p>
              </CardBody>
            </Card>

            <Card className="border border-divider mb-4" disableRipple>
              <CardBody className="p-6">
                <h3 className="text-lg font-medium mb-2">Как долго сохраняется аромат у разных типов продукции?</h3>
                <p className="text-foreground/70">
                  Время горения наших свечей составляет до 45-50 часов, диффузоры сохраняют аромат 3-4 месяца, саше — 2-3 месяца, автопарфюмы — до 30-45 дней, а мелтсы можно использовать многократно в течение 15-20 часов общего времени плавления.
                </p>
              </CardBody>
            </Card>

            <Card className="border border-divider mb-4" disableRipple>
              <CardBody className="p-6">
                <h3 className="text-lg font-medium mb-2">Как правильно ухаживать за ароматическими свечами?</h3>
                <p className="text-foreground/70">
                  Для максимальной эффективности и безопасности рекомендуется: перед каждым использованием подрезать фитиль до 5-7 мм; первое зажигание должно длиться не более 2-3 часов, чтобы воск растопился равномерно по всей поверхности; не оставлять горящую свечу без присмотра; размещать свечу вдали от сквозняков и легковоспламеняющихся предметов.
                </p>
              </CardBody>
            </Card>

            <Card className="border border-divider mb-4" disableRipple>
              <CardBody className="p-6">
                <h3 className="text-lg font-medium mb-2">Можно ли заказать корпоративные подарки с вашей продукцией?</h3>
                <p className="text-foreground/70">
                  Да, мы предлагаем корпоративные подарки и брендированную продукцию. Вы можете выбрать готовые наборы или заказать индивидуальную комплектацию с нанесением вашего логотипа или создание уникального аромата для вашего бренда. Для получения подробной информации свяжитесь с нашим отделом корпоративных продаж.
                </p>
              </CardBody>
            </Card>
          </div>
        </div>
      </section>
    </>
  );
};